<template>
  <ZufallsTeaser />
</template>

<script>
import ZufallsTeaser from "./components/ZufallsTeaser.vue";

export default {
  name: "App",
  components: {
    ZufallsTeaser,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Interstate";
  src: url("~@/assets/b850db31-9043-48a9-9105-f6215999635a-3.woff")
    format("woff");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Interstate";
  src: url("~@/assets/3d6b9143-eb88-4451-80b0-7d05bd58b8a1-3.woff")
    format("woff");
  font-weight: 700;
  font-style: normal;
}

html {
  font-family: "Interstate", Tahoma, Arial, sans-serif;
}
</style>
